import Contract from './contract.js';
import Provider from './provider.js';
export { Contract, Provider };
//# sourceMappingURL=index.js.map